export default __webpack_public_path__ + "static/grid-cc-final-a5269040c4d0bef7352d726779741056.mp4";